module.exports = __webpack_public_path__ + "img/wechat_pay_ico.a85e105f.svg";